/**
 * DocumentChangeSection - Section wrapper for document change cards.
 *
 * Sorts: CREATED -> UPDATED -> DELETED -> SAME.
 */

import { useMemo } from 'react';

import { Badge } from '@/components/ui/catalyst/badge';
import type { ChangedDocumentEntity } from '@/services/api/generated/crossMatterChangesService';

import { CHANGE_TYPE_ORDER } from './changeTypeConfig';
import { DocumentChangeCard } from './DocumentChangeCard';

interface DocumentChangeSectionProps {
  documents: ChangedDocumentEntity[];
}

export const DocumentChangeSection = ({
  documents,
}: DocumentChangeSectionProps) => {
  const sorted = useMemo(
    () =>
      [...documents].sort(
        (a, b) =>
          CHANGE_TYPE_ORDER[a.change_type] -
          CHANGE_TYPE_ORDER[b.change_type],
      ),
    [documents],
  );

  if (documents.length === 0) return null;

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <h3 className="text-base font-semibold text-gray-900">Documents</h3>
        <Badge color="zinc" className="text-xs">
          {documents.length}
        </Badge>
      </div>
      <div className="space-y-2">
        {sorted.map((doc) => (
          <DocumentChangeCard key={doc.entity_id} entity={doc} />
        ))}
      </div>
    </div>
  );
};
